export default __webpack_public_path__ + "static/play_store-d162650d1b2ab44447dca5ad6cd1a147.png";